import { SafeTag, If, Likert } from '@itau-loans-www/components'
import { useProposal } from '@itau-loans-www/hooks'

import Layout from '../../layouts/Summary'
import '../final-screen.scss'
import AppFlux from './components/AppFlux'
import QrCodeFlux from './components/QrCodeFlux'

const FgtsWebAppSuccess = () => {
  const proposalContext = useProposal()
  const qrCode = proposalContext?.product?.proposal?.qrcode ?? ''

  return (
    <Layout>
      <div className="final_screen">
        <SafeTag />
        <If
          condition={!qrCode}
          renderIf={<AppFlux />}
          renderElse={<QrCodeFlux qrCode={qrCode} />}
        />
        <Likert />
      </div>
    </Layout>
  )
}

export default FgtsWebAppSuccess
